import React, { useState } from "react";
import { useForm } from "react-hook-form";

import ArrowRightIcon from "../../images/icons/arrow-right-icon.inline.svg";
import { processForm } from "../../utils/processForm";
import { getSourceImageUrlToCGI } from "../../utils/base";
import subscriptPopupBackground from "../../images/blog/signupFormImg.png";
import { StatusComp } from "../shared/statusComp";
import { useTheme } from "../../context/ThemeContext";

const PopupSubscribe = ({ newsletterPopupDetails }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();

  const [status, setStatus] = useState("");

  const { peopleDomain, planetDomain, currentBrand, localeLanguage } =
    useTheme();

  const onSubmit = async (data) => {
    const formFields = {
      form_type: "newsletter_form",
      newsletter: "newsletter_signup",
      ...data
    };

    setStatus("processing");
    await processForm({
      formdata: formFields,
      peopleDomain,
      planetDomain,
      currentBrand,
      localeLanguage
    });

    setStatus("success");
    reset();
  };

  const expTexts = {
    processing: "Hang tight!",
    success: "Amazing!"
  };
  const statusTexts = {
    processing: "Your email will reach us soon...",
    success: "You are now subscribed to our weekly newsletter."
  };

  const backgroundImage =
    getSourceImageUrlToCGI({
      uri: newsletterPopupDetails?.gbcNewsletterPopUpWdgtImage?.sourceUrl
    }) ?? subscriptPopupBackground;
  const newsletterTitle =
    newsletterPopupDetails?.gbcNewsletterPopUpWdgtTitle ??
    "Subscribe to our weekly newsletter";
  const newsletterSubtitle =
    newsletterPopupDetails?.gbcNewsletterPopUpWdgtSubtitle ??
    "By signing up for this email, you are agreeing to news, offers, and information from GVI and our partners. Click here to visit our ";
  const ctaTitle =
    newsletterPopupDetails?.gbcNewsletterPopUpWdgtCtaTitle ?? "Subscribe";

  return (
    <div
      className="h-full bg-center bg-cover rounded-full"
      style={{ backgroundImage: `url('${backgroundImage}')` }}
    >
      <div className="flex flex-col items-center justify-center h-full text-center sub-form-content">
        {!status ? (
          <form
            id={"newsletter"}
            className="flex justify-between items-center flex-wrap w-full py-8 px-7 flex-col rounded-xxs sm:py-9 sm:px-20"
            onSubmit={handleSubmit(onSubmit)}
          >
            <h2 className="py-2 text-white">{newsletterTitle}</h2>
            <label className="sm:w-full w-[250px] py-2">
              <input
                {...register("email_address", {
                  required: true,
                  pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
                })}
                placeholder="Enter your email address"
                className={`w-full bg-white bg-opacity-5 backdrop-blur-[50px] gvi-border-light gvi-border-05 p-4 text-mob focus:outline-0 font-bold rounded-full dark:rounded-none text-center text-white placeholder:text-white placeholder:font-normal sm:px-6 sm:py-4 sm:text-left ${
                  errors.email_address ? " !border-red-600 " : ""
                }`}
              />
            </label>

            <div className="relative py-2">
              <div className="font-semibold text-gray-darken h8 sm:text-white sm:text-center">
                {newsletterSubtitle}
                <a
                  className="text-white border-b border-white dark:sm:border-white font-semi-bold dark:border-b-white hover:border-b-yellow-standard dark:hover:border-green-standard hover:text-yellow-standard dark:hover:!text-green-standard active:border-b-yellow-standard dark:active:border-green-standard active:text-yellow-standard dark:active:!text-green-standard"
                  href="/privacy"
                  target="_blank"
                >
                  Privacy Policy
                </a>
                . &nbsp;Easy unsubscribe links are provided in every email.
              </div>
            </div>
            <div className="flex justify-center py-2 button-submit w-[233px] sm:mt-0">
              <button
                className="h6 callback-button flex justify-center gap-2 items-center sm:py-4 sm:px-16 border-gray-darker !border-0 dark:gvi-bg-green bg-red-light p-4 rounded-full dark:rounded-xxs w-full !text-white dark:font-bold dark:!text-gray-darker !font-bold text-center"
                type="submit"
              >
                {ctaTitle}
                <ArrowRightIcon className="stroke-white dark:stroke-gray-darker" />
              </button>
            </div>
          </form>
        ) : (
          <div className="w-full py-5">
            <StatusComp
              expText={expTexts[status]}
              statusText={statusTexts[status]}
              status={status}
              align="center"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupSubscribe;
